// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useCallback} from 'react';
import {View, FlatList, LogBox, StyleSheet, Image} from 'react-native';
import {Divider, Menu, ActivityIndicator, Card} from 'react-native-paper';
import {colorSwatches, styles} from '../../../styles';
import {showErrorMessage} from '../../../service/flashMessage';
import MySearchbar from '../../../components/MySearchbar';
import NavbarWithAction from '../../../components/NavbarWithAction';
import {deleteVehicle} from '../../../api/vehicles';
import {useFocusEffect} from '@react-navigation/native';
import {useDispatch, useSelector} from 'react-redux';
import Center from '../../../components/Center';
import {RootStore} from '../../../redux/store';
import {GetVehicles} from '../vehicleReducer';
import {permissionToBool} from '../../../utils';
import IconButton from '../../../components/IconButton';
import Text from '../../../components/Text';
import {E_NAVIGATION_DESTINATIONS} from '../../../@types';
import Container from '../../../components/Container';
import {showKeyboardAwareAlert} from '../../../utils/keyboard';

const VehicleItem = ({
  vehicle,
  onSelectDelete,
  onSelectEdit,
  itemClickHandler,
  currentLink,
}) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const imageUrl = vehicle.vehicleImage
    ? `data:image/jpeg;base64,${vehicle.vehicleImage}`
    : 'https://ford.prodealerwebsites.com.au/specials/default.png';

  return (
    <Card style={localStyles.card} onPress={() => itemClickHandler()}>
      <View style={localStyles.cardContent}>
        <Image
          source={{
            uri: imageUrl,
          }}
          style={localStyles.cardImage}
        />
        <View style={localStyles.cardTextContainer}>
          <Text style={localStyles.vehicleOwner}>{vehicle.vehicleOwner}</Text>
          <Text>{vehicle.licensePlate}</Text>
          <View style={localStyles.dateContainer}>
            <Text style={localStyles.dateText}>
              {`${new Date(
                vehicle?.dateFrame?.startDate,
              ).toLocaleDateString()} - ${new Date(
                vehicle?.dateFrame?.endDate,
              ).toLocaleDateString()}`}
            </Text>
          </View>
        </View>
        {(permissionToBool(currentLink?.vehiclePermission?.charAt(1)) ||
          permissionToBool(currentLink?.vehiclePermission?.charAt(4))) && (
          <View style={localStyles.menuContainer}>
            <Menu
              visible={menuVisible}
              onDismiss={() => setMenuVisible(false)}
              anchor={
                <IconButton
                  icon="ellipsis-vertical"
                  iconColor={'#718096'}
                  size={24}
                  onPress={() => setMenuVisible(true)}
                />
              }>
              {permissionToBool(currentLink?.vehiclePermission?.charAt(1)) && (
                <>
                  <Menu.Item
                    onPress={() => {
                      setMenuVisible(false);
                      onSelectEdit();
                    }}
                    title="Edit"
                  />
                  <Divider />
                </>
              )}
              {permissionToBool(currentLink?.vehiclePermission?.charAt(4)) && (
                <Menu.Item
                  onPress={() => {
                    setMenuVisible(false);
                    onSelectDelete();
                  }}
                  title="Delete"
                />
              )}
            </Menu>
          </View>
        )}
      </View>
    </Card>
  );
};

const Vehicles = ({navigation}) => {
  const {vehicles, loading} = useSelector((state: RootStore) => state.vehicles);
  const [searchTerm, setSearchTerm] = useState('');
  const [isNavbarShown, setIsNavbarShown] = useState(true);
  const dispatch = useDispatch();

  const currentLink = useSelector(
    (state: RootStore) => state.units.unitLinks,
  ).filter(link => link.isDefault === true)[0];

  const deleteVehicleWithId = async vehicleId => {
    try {
      await deleteVehicle(vehicleId);
      dispatch(GetVehicles(''));
    } catch (error) {
      showErrorMessage(error.toString());
    }
  };

  const ignoreListsWarnings = () => {
    LogBox.ignoreLogs(['VirtualizedLists should never be nested']);
  };

  useFocusEffect(
    useCallback(() => {
      dispatch(GetVehicles(searchTerm));
      ignoreListsWarnings();
    }, [searchTerm]),
  );

  const showDeleteUnitPrompt = (vehicleId: string) => {
    showKeyboardAwareAlert(
      '',
      'Do you really want to delete vehicle ?',
      [
        {
          text: 'NO',
          onPress: () => console.log('Cancel Pressed'),
          style: 'cancel',
        },
        {
          text: 'YES',
          onPress: () => deleteVehicleWithId(vehicleId),
        },
      ],
      {
        cancelable: true,
      },
    );
  };

  const MainComponent = () => {
    return (
      <>
        {loading ? (
          <ActivityIndicator
            animating={true}
            color={colorSwatches.primary.color}
            style={localStyles.loadingIndicator}
          />
        ) : (
          <>
            <FlatList
              data={vehicles}
              style={localStyles.flatList}
              showsVerticalScrollIndicator={false}
              ListEmptyComponent={<Center>No vehicles found</Center>}
              ListFooterComponent={<View style={localStyles.footer} />}
              renderItem={({item}) => (
                <VehicleItem
                  vehicle={item}
                  onSelectDelete={() => showDeleteUnitPrompt(item.id)}
                  onSelectEdit={() =>
                    navigation.navigate(
                      E_NAVIGATION_DESTINATIONS.VEHICLE_EDIT,
                      {vehicle: item},
                    )
                  }
                  itemClickHandler={() =>
                    navigation.navigate('Vehicle Detail', {vehicleId: item.id})
                  }
                  currentLink={currentLink}
                />
              )}
            />
          </>
        )}
      </>
    );
  };

  return (
    <Container>
      {isNavbarShown ? (
        <NavbarWithAction
          navigation={navigation}
          hasBackArrow
          hasSearch={vehicles.length > 0}
          title="Vehicles"
          showCurrentUnit
          onClickSearch={() => setIsNavbarShown(false)}
          hasAdd={permissionToBool(currentLink?.vehiclePermission?.charAt(3))}
          onClickAdd={() =>
            navigation.navigate(E_NAVIGATION_DESTINATIONS.VEHICLE_ADD, {
              vehicle: null,
            })
          }
          fullScreen
        />
      ) : (
        <MySearchbar
          placeholder="Search by license plate"
          setValue={(val: string) => {
            setSearchTerm(val);
          }}
          resetSearch={() => {
            setSearchTerm('');
            setIsNavbarShown(true);
          }}
        />
      )}
      <MainComponent />
    </Container>
  );
};

const localStyles = StyleSheet.create({
  card: {
    marginVertical: 8,
    borderRadius: 8,
  },
  cardContent: {
    flexDirection: 'row',
    padding: 8,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardImage: {
    width: 116,
    height: '100%',
    borderRadius: 6,
  },
  cardTextContainer: {
    flex: 1,
    marginLeft: 8,
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  vehicleOwner: {
    fontSize: 18,
  },
  dateContainer: {
    flex: 1,
    flexDirection: 'row',
    marginTop: 32,
  },
  dateText: {
    marginLeft: 4,
    fontSize: 12,
  },
  menuContainer: {
    marginTop: 16,
    marginRight: 16,
  },
  loadingIndicator: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  flatList: {
    padding: 8,
    flex: 1,
  },
  footer: {
    height: 96,
  },
});

export default Vehicles;
